  /* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    Grid,
    makeStyles,
    createStyles,
    Theme,
} from "@material-ui/core";
import React from "react";
import { IEquipment, IEquipmentCategory, IPropertyType, IPropertyTypeInputs, PropertyInputs } from "../../../../utils/AnnounceInterfaces";
import { PropertyTextField } from "../PropertyTextField";
import { PropertyService } from '../../services/PropertyService';
import { PropertyTextFieldNumber } from "../PropertyTextFieldNumber";
import { equipmentsDefaultValue } from "../../../../utils/defaultNullValues";
import AutoCompleteWithChips from '../../../components/OverridingMaterial/AutoCompleteWithChips';
import { useTranslation } from 'react-i18next'
import { HotelService } from "../../../Admin/Hotel/services/hotelService";
import { UserContext } from "../../../../contexts/AppContext";
import AutoCompleteSolo from "../../../components/OverridingMaterial/AutoCompleteSolo";
import AutoCompleteHotel from "../../../components/OverridingMaterial/autoCompleteHotel";
import { useQuery } from "../../../../utils/App";
import { EquipmentService } from "../../../Admin/Equipments/services/EquipmentService";
import { CheckableTreeItem } from "../../../../utils/checkableTreeItem";
import { Select, MenuItem, FormControl, InputLabel, FormControlLabel, Checkbox, Button, TextField } from "@material-ui/core";
import { LocalizationProvider, DatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { TimePicker } from "@material-ui/pickers";
import { format } from "date-fns";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';


const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6
        },
        inputText: {
            marginBottom: 14,
            marginTop: 6,
            textAlign: "left"
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        category: {
            marginTop: 10,
            fontSize: "initial",
        },
        halfWidth: {
            width: '50%', // Set the width to 50%
          },
    })
);

const propertyService = new PropertyService();
const hotelService = new HotelService();
const equipmentService = new EquipmentService();

const languageOptions: Record<string, { value: string; label: string }[]> = {
    en: [
        { value: 'French', label: 'French' },
        { value: 'English', label: 'English' },
        { value: 'Chinese', label: 'Chinese' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'Italian', label: 'Italian' },
        { value: 'German', label: 'German' },
        { value: 'Arabic', label: 'Arabic' }
    ],
    fr: [
        { value: 'Français', label: 'Français' },
        { value: 'Anglais', label: 'Anglais' },
        { value: 'Chinois', label: 'Chinois' },
        { value: 'Espagnol', label: 'Espagnol' },
        { value: 'Italien', label: 'Italien' },
        { value: 'Allemand', label: 'Allemand' },
        { value: 'Arabe', label: 'Arabe' }
    ]
};

const cuisineOptions: Record<string, { value: string; label: string }[]> = {
    fr: [
        { value: 'Africaine', label: 'Africaine' },
        { value: 'Allemande', label: 'Allemande' },
        { value: 'Anglaise', label: 'Anglaise' },
        { value: 'Arabe', label: 'Arabe' },
        { value: 'Boutique de Desserts', label: 'Boutique de Desserts' }, // For specialized dessert places
        { value: 'Café', label: 'Café' }, // For ice cream, cakes, etc.
        { value: 'Camerounaise', label: 'Camerounaise' },
        { value: 'Chinoise', label: 'Chinoise' },
        { value: 'Espagnole', label: 'Espagnole' },
        { value: 'Européenne', label: 'Européenne' },
        { value: 'Fast Food', label: 'Fast Food' },
        { value: 'Française', label: 'Française' },
        { value: 'Gabonaise', label: 'Gabonaise' },
        { value: 'Glaces', label: 'Glaces' }, // Ice Cream
        { value: 'Grecque', label: 'Grecque' }, // Added Greek cuisine
        { value: 'Indienne', label: 'Indienne' },
        { value: 'Internationale', label: 'Internationale' },
        { value: 'Irlandaise', label: 'Irlandaise' },
        { value: 'Italienne', label: 'Italienne' },
        { value: 'Ivoirienne', label: 'Ivoirienne' },
        { value: 'Locale', label: 'Locale' },
        { value: 'Marocaine', label: 'Marocaine' },
        { value: 'Méditéranéenne', label: 'Méditéranéenne' }, // Added Mediterranean cuisine
        { value: 'Napolitaine', label: 'Napolitaine' }, // Added Neapolitan cuisine
        { value: 'Pâtisserie', label: 'Pâtisserie' }, // For bakeries and pastry shops
        { value: 'Pizza', label: 'Pizza' },
        { value: 'Russe', label: 'Russe' },
        { value: 'Sénégalaise', label: 'Sénégalaise' },
        { value: 'Sicilienne', label: 'Sicilienne' }, // Added Sicilian cuisine
        { value: 'Vietnamienne', label: 'Vietnamienne' },
    ],
    en: [
        { value: 'African', label: 'African' },
        { value: 'Arabic', label: 'Arabic' },
        { value: 'Bakery', label: 'Bakery' }, // Equivalent to Pâtisserie
        { value: 'Café', label: 'Café' }, // For ice cream, cakes, etc.
        { value: 'Cameroonian', label: 'Cameroonian' },
        { value: 'Chinese', label: 'Chinese' },
        { value: 'Dessert Shop', label: 'Dessert Shop' }, // For specialized dessert places
        { value: 'English', label: 'English' },
        { value: 'European', label: 'European' },
        { value: 'Fast Food', label: 'Fast Food' },
        { value: 'French', label: 'French' },
        { value: 'Gabonese', label: 'Gabonese' },
        { value: 'German', label: 'German' },
        { value: 'Greek', label: 'Greek' }, // Added Greek cuisine
        { value: 'Ice Cream', label: 'Ice Cream' },
        { value: 'Indian', label: 'Indian' },
        { value: 'International', label: 'International' },
        { value: 'Irish', label: 'Irish' },
        { value: 'Italian', label: 'Italian' },
        { value: 'Ivorian', label: 'Ivorian' },
        { value: 'Local', label: 'Local' },
        { value: 'Mediterranean', label: 'Mediterranean' }, // Added Mediterranean cuisine
        { value: 'Moroccan', label: 'Moroccan' },
        { value: 'Neapolitan', label: 'Neapolitan' }, // Added Neapolitan cuisine
        { value: 'Pastry Shop', label: 'Pastry Shop' }, // For bakeries and pastry shops
        { value: 'Pizza', label: 'Pizza' },
        { value: 'Russian', label: 'Russian' },
        { value: 'Senegalese', label: 'Senegalese' },
        { value: 'Sicilian', label: 'Sicilian' }, // Added Sicilian cuisine
        { value: 'Spanish', label: 'Spanish' },
        { value: 'Vietnamese', label: 'Vietnamese' },
    ],
};

interface PropertyLanguageSelectProps {
    values: { trs_langage: string };
    handleChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

interface DayHours {
    open1: string; // First opening time
    close1: string; // First closing time
    open2: string; // Second opening time
    close2: string; // Second closing time
    isClosed: boolean; // Whether the day is closed
    hasSecondTimeSlot: boolean; 
}

type OpeningHours = {
    Sunday: DayHours;
    Monday: DayHours;
    Tuesday: DayHours;
    Wednesday: DayHours;
    Thursday: DayHours;
    Friday: DayHours;
    Saturday: DayHours;
};

export function StepOne(props: {
    values: PropertyInputs;
    handleChange: (e: any) => void;
    handleChangePropertyType: (e: any) => void;
    propertyTypeValues: IPropertyTypeInputs
    onChangeMultiSelect: (v: any) => void;
    handleChangeCheckedJardin: (v: any) => void;
    propertyTypeList: IPropertyType[];
    equipmentsSelected: string[];
    onChangeHotel: (e: any) => void;
    propertyHotel: any;
    hoteSelected: any;
    hotelList: any;
    typeSelected: any;
    choixHotel: any;
    setEquipments: any;
    equipments: any;
    searchTypeName?: string;
}) {
    props.equipments = props.equipments || [];
    const query = useQuery()
    const classes = styles();
    const [equipmentsList, setEquipmentsList] = React.useState<IEquipment[]>(equipmentsDefaultValue)
    const [filteredPropertyTypeList, setFilteredPropertyTypeList] = React.useState<IPropertyType[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [categorie, setCategorie] = React.useState<any>([])
    const { t, i18n } = useTranslation<'common'>();
    const [hotel, setHotel] = React.useState<any>([])
    const userContext = React.useContext(UserContext);
    const { user } = userContext;
    const SearchTypeName = props.searchTypeName;
    const currentLang = (i18n.language in languageOptions ? i18n.language : "en") as keyof typeof languageOptions;
    const currentCuis = (i18n.language in cuisineOptions ? i18n.language : "en") as keyof typeof cuisineOptions;

    const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedValues = event.target.value as string[];
        props.handleChange({ target: { name: "trs_langage", value: selectedValues.join(", ") } });
    };
    

      // Log initial prop values
      //console.log("StepOne props:", props);
      //console.log("Initial props.propertyTypeList:", props.propertyTypeList);

    // Function to sort categories by name
    function SortArray(x : any,y : any){
        if(x.category.name < y.category.name){return -1;}
        if(x.category.name > y.category.name){return 1;}
        return 0;
    }


    const [openingHours, setOpeningHours] = React.useState<OpeningHours>(
        (typeof props.values.trs_openingHours === "object" && props.values.trs_openingHours !== null
            ? (props.values.trs_openingHours as unknown as OpeningHours)
            : {
                Sunday: { open1: "09:00", close1: "12:00", open2: "14:00", close2: "18:00", isClosed: false, hasSecondTimeSlot: true },
                Monday: { open1: "09:00", close1: "12:00", open2: "14:00", close2: "18:00", isClosed: false, hasSecondTimeSlot: true },
                Tuesday: { open1: "09:00", close1: "12:00", open2: "14:00", close2: "18:00", isClosed: false, hasSecondTimeSlot: true },
                Wednesday: { open1: "09:00", close1: "12:00", open2: "14:00", close2: "18:00", isClosed: false, hasSecondTimeSlot: true },
                Thursday: { open1: "09:00", close1: "12:00", open2: "14:00", close2: "18:00", isClosed: false, hasSecondTimeSlot: true },
                Friday: { open1: "09:00", close1: "12:00", open2: "14:00", close2: "18:00", isClosed: false, hasSecondTimeSlot: true },
                Saturday: { open1: "09:00", close1: "12:00", open2: "14:00", close2: "18:00", isClosed: false, hasSecondTimeSlot: true },
            }
        )
    );
    
    const handleToggleSecondTimeSlot = (day: keyof OpeningHours, hasSecondTimeSlot: boolean) => {
        const updatedOpeningHours = {
            ...openingHours,
            [day]: { ...openingHours[day], hasSecondTimeSlot },
        };
        setOpeningHours(updatedOpeningHours);
        props.handleChange({ target: { name: "trs_openingHours", value: updatedOpeningHours } });
    };

   // Add type annotations to handleTimeChange
   const handleTimeChange = (
    day: keyof OpeningHours,
    field: keyof DayHours, // Can be 'open1', 'close1', 'open2', or 'close2'
    time: string
) => {
    const updatedOpeningHours = {
        ...openingHours,
        [day]: { ...openingHours[day], [field]: time },
    };
    setOpeningHours(updatedOpeningHours);
    props.handleChange({ target: { name: "trs_openingHours", value: updatedOpeningHours } });
};

// Add type annotations to handleClosedChange
const handleClosedChange = (day: keyof OpeningHours, isClosed: boolean) => {
    const updatedOpeningHours = {
        ...openingHours,
        [day]: { ...openingHours[day], isClosed },
    };
    setOpeningHours(updatedOpeningHours);
    props.handleChange({ target: { name: "trs_openingHours", value: updatedOpeningHours } });
};

    React.useEffect(() => {
        // Ensure SearchTypeName is a string or provide a default value
        const searchTypeString = SearchTypeName || '';
        //("searchTypeString:", searchTypeString);
    
        if (props.propertyTypeList) {
            const filteredList = props.propertyTypeList.filter(
                (type: IPropertyType) =>
                    type.searchType?.name?.toString() === searchTypeString
                
            );

            //console.log("Filtered Property Type List:", filteredList); // Log filtered list
            setFilteredPropertyTypeList(filteredList);
        }
    }, [props.propertyTypeList, SearchTypeName]);
    
    React.useEffect(() => {
        //console.log("Fetching all categories...");
        setLoading(true);
    
        if (!SearchTypeName) {
            // If SearchTypeName is undefined, skip the API call
            setCategorie([]);
            setLoading(false);
            return;
        }
    
        equipmentService.getAllCategories()
            .then(response => {
                if (response.success) {
                    // Filter categories based on SearchTypeName
                    const filteredCategories = response.data.filter(
                        (category: IEquipmentCategory) => 
                            category.applicableSearchTypes?.includes(SearchTypeName)
                    );
                    
                    //console.log("Filtered Categories:", filteredCategories); // Log filtered categories
                    setCategorie(filteredCategories);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
                setLoading(false);
            });
    }, [SearchTypeName]); // Only re-run effect when SearchTypeName changes
    
       
      
    React.useEffect(() => {
        setLoading(true);
        propertyService.getAllEquipments().then((response) => {
            if (response.success) {
                // Filter equipments based on SearchTypeName
                const filteredEquipments = response.data.filter(
                    (equipment: IEquipment) =>
                        equipment.applicableSearchTypes?.includes(SearchTypeName || '')
                );
                setEquipmentsList(filteredEquipments.sort(SortArray));
            } else {
                console.error("Failed to fetch equipments:", response);
            }
            setLoading(false);
        }).catch((err: any) => {
            console.error("Error fetching equipments:", err);
            setLoading(false);
        });
    }, [SearchTypeName]);

    // Fetch user hotels
    React.useEffect(() => {
        //console.log("Fetching hotels for user:", user?._id);
        setLoading(true);
        hotelService.getHotelByUser(user?._id).then(response => {
            if (response.success) {
                //console.log("Hotels fetched:", response.hotel);
                setHotel(response.hotel);
            } else {
                console.error("Failed to fetch hotels:", response);
            }
            setLoading(false);
        }).catch(err => {
            console.error("Error fetching hotels:", err);
            setLoading(false);
        })
    }, [user]);

    // Scroll to top on component load
    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    // Build the equipment list by category
    let tab_eq: any = [];
    categorie?.forEach((catego: any) => {
        let eqmt = equipmentsList?.filter(eq => eq.category?._id === catego._id);
        tab_eq.push({
            categorie: catego.name[i18n.language as 'en' | 'fr'] || "Unknown", // Use optional chaining and fallback to "Unknown"
            equipement: eqmt
        });
    });
    //console.log("tab_eq structure:", tab_eq);

    // Handle equipment selection
    const handleCheck = (eq: any) => {
        if (props.equipments.find((el: any) => el === eq._id)) {
            props.setEquipments((prev: any) => prev.filter((el: any) => el !== eq._id));
        } else {
            props.setEquipments((prev: any) => [...prev, eq._id]);
        }
    };

    React.useEffect(()=>{
        hotelService.getHotelByUser(user._id).then(response=>{
            if(response.success){
                setHotel(response.hotel)
                setLoading(false)
            }
        }).catch(err=>{
            setLoading(false)
        })
    },[setLoading, setHotel])

    const labelPropertyType = (SearchTypeName === "cars") ? t('propriete.labels.typeDeVehicule') : t('propriete.labels.typeDePropriete');

    const carBrands = [
        "Toyota", "Honda", "Renault", "Peugeot", "Nissan", "Volkswagen", "Ford",
        "Mercedes-Benz", "BMW", "Hyundai", "Kia", "Chevrolet", "Mitsubishi",
        "Suzuki", "Isuzu", "Land Rover", "Jeep", "Dacia", "Fiat", "Chery",
        "Citroën", "Seat", "Tacoma", "Mazda", "Subaru", "Lexus", "Opel", "GMC",
        "Changan", "Tata Motors", "Mahindra", "SsangYong", "Geely", "BYD",
        "Great Wall Motors", "Dongfeng", "FAW", "Proton", "Daewoo", "Alfa Romeo"
    ].sort();    


    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container style={{ textAlign: "left" }}>
                    {
                        (query.get("ajout") === "Hôtel") || query.get('ajout') === "exist" ?
                            (props.propertyTypeList.length > 0 && <PropertyTextField
                                id="propertyName"
                                label={`${t('propriete.labels.typeDePropriete')}  : "`}
                                name="name"
                                value={props.propertyTypeList.filter((val: any) => val.name === "Hôtel")[0].name}
                                handleChange={() => props.handleChangePropertyType(props.propertyTypeList.filter((val: any) => val.name === "Hôtel")?.[0]?._id)}
                            />) :
                            (<>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <label
                                        htmlFor="propertyCountry"
                                        className={classes.inputLabel}
                                        style={{ display: "block" }}
                                    >
                                        {labelPropertyType}
                                    </label>
                                </Grid>
                                <Grid item lg={12} sm={12} md={12} xs={12} className={classes.inputText}>
                                    <AutoCompleteSolo
                                        id="propertyEquipments"
                                        name="name"
                                        selectedValues={props.typeSelected}
                                        values={filteredPropertyTypeList}
                                        onChangeSelect={props.handleChangePropertyType}
                                    />
                                </Grid>
                            </>)
                    }
    
                    {
                        query.get('ajout') === "exist" ? <>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <label
                                    htmlFor="propertyCountry"
                                    className={classes.inputLabel}
                                    style={{ display: "block" }}
                                >
                                    {t('label.hotel')}:
                                </label>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} className={classes.inputText}>
                                <AutoCompleteHotel
                                    id="propertyEquipments"
                                    name="name"
                                    selectedValues={props.hoteSelected}
                                    values={props.hotelList}
                                    onChangeSelect={props.onChangeHotel}
                                />
                            </Grid>
                        </> : <></>
                    }
    
                    {SearchTypeName === "cars" && (
                        <>
                            <PropertyTextField
                                id="propertyCarName"
                                label={`${t('propriete.labels.nomDuVehicule')} * :`}
                                name="name"
                                value={props.values.name ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextFieldNumber
                id="propertyPassengers"
                label={`${t('propriete.labels.nombreMaximumPassengers')} * :`}
                name="vhcl_passengers"
                value={props.values.vhcl_passengers  || 0}
                handleChange={(e) =>
                    props.handleChange({ target: { name: 'vhcl_passengers', value: Number(e.target.value) } })
                }
            />
            <PropertyTextFieldNumber
                id="propertyBags"
                label={`${t('propriete.labels.nombreDeBags')} * :`}
                name="vhcl_bags"
                value={props.values.vhcl_bags  || 0}
                handleChange={(e) =>
                    props.handleChange({ target: { name: 'vhcl_bags', value: Number(e.target.value) } })
                }
            />
            <PropertyTextFieldNumber
                id="propertyDoors"
                label={`${t('propriete.labels.nombreDeDoors')} * :`}
                name="vhcl_doors"
                value={props.values.vhcl_doors  || 0}
                handleChange={(e) =>
                    props.handleChange({ target: { name: 'vhcl_doors', value: Number(e.target.value) } })
                }
            />
            <FormControl variant="outlined" fullWidth style={{ marginBottom: "10px" }}>
                <InputLabel id="carBrandLabel">
                    {`${t("propriete.labels.carBrand")} *`}
                </InputLabel>
                <Select
                    id="carBrand"
                    labelId="carBrandLabel"
                    label={`${t("propriete.labels.carBrand")} *`}
                    name="vhcl_brand"
                    value={props.values.vhcl_brand ?? ""} // Controlled value
                    onChange={props.handleChange} // Pass the handler to update state
                >
                    {carBrands.map((brand) => (
                        <MenuItem key={brand} value={brand}>
                            {brand}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <PropertyTextField
                id="propertyModel"
                label={`${t('propriete.labels.carModel')} * :`}
                name="vhcl_model"
                value={props.values.vhcl_model ?? ""}
                handleChange={props.handleChange}
            />
            <label style={{ marginBottom: '6px', marginTop: '14px', display: 'block' }}>{t('propriete.labels.carFuel')}</label>
            <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                <InputLabel id="propertyFuelType">{`${t('propriete.labels.carFuel')} * :`}</InputLabel>
                <Select
                    id="propertyFuelType"
                    labelId="propertyFuelTypeLabel"
                    label={`${t('propriete.labels.carFuel')}  * :`}
                    name="vhcl_fuelType"
                    value={props.values.vhcl_fuelType ?? ""} // Ensure a valid value is provided
                    onChange={props.handleChange} // The function to handle the value change
                >
                    <MenuItem value="essence">{t('propriete.labels.essence')}</MenuItem>
                    <MenuItem value="diesel">{t('propriete.labels.diesel')}</MenuItem>
                    <MenuItem value="electric">{t('propriete.labels.electric')}</MenuItem>
                    <MenuItem value="hybrid">{t('propriete.labels.hybrid')}</MenuItem>
                </Select>
            </FormControl>
            <PropertyTextFieldNumber
                id="propertyYear"
                label={`${t('propriete.labels.carYear')} * :`}
                name="vhcl_year"
                value={props.values.vhcl_year  || 0}
                handleChange={(e) =>
                    props.handleChange({ target: { name: 'vhcl_year', value: Number(e.target.value) } })
                }
            />
            <PropertyTextField
                id="propertyPlaqueId"
                label={`${t('propriete.labels.plaqueID')} * :`}
                name="vhcl_plaqueId"
                value={props.values.vhcl_plaqueId ?? ""}
                handleChange={props.handleChange}
            />
            <PropertyTextField
                id="propertyChassisId"
                label={`${t('propriete.labels.chassis')} * :`}
                name="vhcl_chassisId"
                value={props.values.vhcl_chassisId ?? ""}
                handleChange={props.handleChange}
            />
            <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                <InputLabel id="propertyExtColorLabel">{`${t('propriete.labels.couleurExterne')} * :`}</InputLabel>
                <Select
                    id="propertyExtColor"
                    labelId="propertyExtColorLabel"
                    label={`${t('propriete.labels.couleurExterne')} * :`}
                    name="vhcl_color"
                    value={props.values.vhcl_color ?? ""}
                    onChange={props.handleChange}
                >
                    <MenuItem value="black">{t('propriete.options.couleurs.noir')}</MenuItem>
                    <MenuItem value="white">{t('propriete.options.couleurs.blanc')}</MenuItem>
                    <MenuItem value="gray">{t('propriete.options.couleurs.gris')}</MenuItem>
                    <MenuItem value="red">{t('propriete.options.couleurs.rouge')}</MenuItem>
                    <MenuItem value="blue">{t('propriete.options.couleurs.bleu')}</MenuItem>
                    <MenuItem value="green">{t('propriete.options.couleurs.vert')}</MenuItem>
                    <MenuItem value="silver">{t('propriete.options.couleurs.argent')}</MenuItem>
                    <MenuItem value="gold">{t('propriete.options.couleurs.or')}</MenuItem>
                    <MenuItem value="brown">{t('propriete.options.couleurs.marron')}</MenuItem>
                    <MenuItem value="yellow">{t('propriete.options.couleurs.jaune')}</MenuItem>
                    <MenuItem value="bordeaux">{t('propriete.options.couleurs.bordeaux')}</MenuItem>
                </Select>
            </FormControl>
            
            <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                <InputLabel id="propertyIntColorLabel">{`${t('propriete.labels.couleurInterne')} * :`}</InputLabel>
                <Select
                    id="propertyIntColor"
                    labelId="propertyIntColorLabel"
                    label={`${t('propriete.labels.couleurInterne')} * :`}
                    name="vhcl_interiorColor"
                    value={props.values.vhcl_interiorColor ?? ""}
                    onChange={props.handleChange}
                >
                    <MenuItem value="black">{t('propriete.options.couleurs.noir')}</MenuItem>
                    <MenuItem value="white">{t('propriete.options.couleurs.blanc')}</MenuItem>
                    <MenuItem value="beige">{t('propriete.options.couleurs.beige')}</MenuItem>
                    <MenuItem value="gray">{t('propriete.options.couleurs.gris')}</MenuItem>
                    <MenuItem value="brown">{t('propriete.options.couleurs.marron')}</MenuItem>
                    <MenuItem value="red">{t('propriete.options.couleurs.rouge')}</MenuItem>
                    <MenuItem value="blue">{t('propriete.options.couleurs.bleu')}</MenuItem>
                </Select>
            </FormControl>

            <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                <InputLabel id="propertySeatFabricLabel">{`${t('propriete.labels.seatFabric')} * :`}</InputLabel>
                <Select
                    id="propertySeatFabric"
                    labelId="propertySeatFabricLabel"
                    label={`${t('propriete.labels.seatFabric')} * :`}
                    name="vhcl_seatFabric"
                    value={props.values.vhcl_seatFabric ?? ""}
                    onChange={props.handleChange}
                >
                    <MenuItem value="leather">{t('propriete.options.seatFabric.cuir')}</MenuItem>
                    <MenuItem value="fabric">{t('propriete.options.seatFabric.tissu')}</MenuItem>
                    <MenuItem value="alcantara">{t('propriete.options.seatFabric.alcantara')}</MenuItem>
                    <MenuItem value="vinyl">{t('propriete.options.seatFabric.vinyle')}</MenuItem>
                </Select>
            </FormControl>
            
            <label style={{ marginBottom: '6px', marginTop: '14px', display: 'block' }}>{t('propriete.labels.gearBox')}</label>
            <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                <InputLabel id="propertyGearBoxLabel">{`${t('propriete.labels.gearBox')} * :`}</InputLabel>
                <Select
                    id="propertyGearBox"
                    labelId="propertyGearBoxLabel"
                    label={`${t('propriete.labels.gearBox')} * :`}
                    name="vhcl_gearBox"
                    value={props.values.vhcl_gearBox ?? ""} // Ensure a valid value is provided
                    onChange={props.handleChange} // The function to handle the value change
                >
                    <MenuItem value="automatic">{t('propriete.labels.automatic')}</MenuItem>
                    <MenuItem value="manual">{t('propriete.labels.manual')}</MenuItem>
                </Select>
            </FormControl>
            <PropertyTextFieldNumber
                id="propertyEnginePower"
                label={`${t('propriete.labels.enginePower')} * :`}
                name="vhcl_enginePower"
                value={props.values.vhcl_enginePower || 0}
                handleChange={(e) =>
                    props.handleChange({ target: { name: 'vhcl_enginePower', value: Number(e.target.value) } })
                }
            />
            <PropertyTextFieldNumber
                id="propertyKilometers"
                label={`${t('propriete.labels.kilometrageInitial')} * :`}
                name="vhcl_kilometers"
                value={props.values.vhcl_kilometers || 0}
                handleChange={(e) =>
                    props.handleChange({ target: { name: 'vhcl_kilometers', value: Number(e.target.value) } })
                }
            />
            <PropertyTextField
                id="propertyInsuranceProvider"
                label={`${t('propriete.labels.insuranceProvider')} * :`}
                name="vhcl_insuranceProvider"
                value={props.values.vhcl_insuranceProvider ?? ""}
                handleChange={props.handleChange}
            />
            <TextField
                id="insurancExpiryDate"
                label={t("propriete.labels.insuranceExpiryDate")}
                variant="outlined"
                type="date"
                margin="normal"
                InputLabelProps={{
                    shrink: true,
                }}
                value={
                    props.values.vhcl_insuranceExpiryDate && !isNaN(new Date(props.values.vhcl_insuranceExpiryDate).getTime())
                        ? new Date(props.values.vhcl_insuranceExpiryDate).toISOString().split("T")[0]
                        : ""
                }
                onChange={(event) => {
                    const newDate = new Date(event.target.value);
                    if (!isNaN(newDate.getTime())) {
                        // Update the state only if the date is valid
                        props.handleChange({
                            target: {
                                name: "vhcl_insuranceExpiryDate",
                                value: newDate.toISOString().split("T")[0], // Keep the date in YYYY-MM-DD format
                            },
                        });
                    }
                }}
                style={{
                    width: '33%',
                    borderRadius: 8, // Rounded corners for the input
                }}
                placeholder={t("propriete.labels.entrezInsuranceExpiryDate")}
            />
                        </>
                    )}
    
                    {SearchTypeName === "rstt" && (
                        <>
                            <PropertyTextField
                                id="propertyName"
                                label={`${t('propriete.labels.rstt_nomDeLaPropriete')} * :`}
                                name="name"
                                value={props.values.name ?? ""}
                                handleChange={props.handleChange}
                            />
                            <label style={{ marginBottom: '6px', marginTop: '14px', display: 'block' }}>{t('propriete.labels.rstt_typeAnnonce')}</label>
                    <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                        <InputLabel id="rstt_typeAnnonceLabel">{`${t('propriete.labels.rstt_typeAnnonce')} * :`}</InputLabel>
                        <Select
                            id="rstt_typeAnnonce"
                            labelId="rstt_typeAnnonce"
                            label={`${t('propriete.labels.rstt_typeAnnonce')} * :`}
                            name="rstt_typeAnnonce"
                            value={props.values.rstt_typeAnnonce ?? ""} // Ensure a valid value is provided
                            onChange={props.handleChange} // The function to handle the value change
                        >
                            <MenuItem value="rental">{t('propriete.labels.rental')}</MenuItem>
                            <MenuItem value="sale">{t('propriete.labels.sale')}</MenuItem>
                        </Select>
                    </FormControl>
                    <PropertyTextFieldNumber
                        id="rstt_numberOfBedrooms"
                        label={`${t('propriete.labels.rstt_numberOfBedrooms')}  :`}
                        name="rstt_numberOfBedrooms"
                        value={props.values.rstt_numberOfBedrooms  || 0}
                        handleChange={(e) =>
                            props.handleChange({ target: { name: 'rstt_numberOfBedrooms', value: Number(e.target.value) } })
                        }
                    />
                    <PropertyTextFieldNumber
                        id="rstt_numberOfBathrooms"
                        label={`${t('propriete.labels.numberOfBathrooms')}  :`}
                        name="rstt_numberOfBathrooms"
                        value={props.values.rstt_numberOfBathrooms  || 0}
                        handleChange={(e) =>
                            props.handleChange({ target: { name: 'rstt_numberOfBathrooms', value: Number(e.target.value) } })
                        }
                    />
                    <PropertyTextFieldNumber
                        id="rstt_surfaceHabitable"
                        label={`${t('propriete.labels.surfaceHabitable')} :`}
                        name="rstt_surfaceHabitable"
                        value={props.values.rstt_surfaceHabitable || 0}
                        handleChange={(e) =>
                            props.handleChange({ target: { name: 'rstt_surfaceHabitable', value: Number(e.target.value) } })
                        }
                    />
                    <PropertyTextFieldNumber
                        id="rstt_superficieTerrain"
                        label={`${t('propriete.labels.superficieTerrain')} :`}
                        name="rstt_superficieTerrain"
                        value={props.values.rstt_superficieTerrain  || 0}
                        handleChange={(e) =>
                            props.handleChange({ target: { name: 'rstt_superficieTerrain', value: Number(e.target.value) } })
                        }
                    />
                    <PropertyTextFieldNumber
                        id="rstt_yearBuilt"
                        label={`${t('propriete.labels.rstt_yearBuilt')}  :`}
                        name="rstt_yearBuilt"
                        value={props.values.rstt_yearBuilt  || 0}
                        handleChange={(e) =>
                            props.handleChange({ target: { name: 'rstt_yearBuilt', value: Number(e.target.value) } })
                        }
                    /> 
                        </>
                    )}
    
                    {SearchTypeName === "trs" && (
                        <>
                            <PropertyTextField
                                id="propertyName"
                                label={`${t('propriete.labels.trs_nomDeLaPropriete')} * :`}
                                name="name"
                                value={props.values.name ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="property_slug"
                                label={`${t('propriete.labels.trs_slug')} * :`}
                                name="trs_slug"
                                value={props.values.trs_slug ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_phoneNumber"
                                label={`${t('propriete.labels.trs_phoneNumber')}  :`}
                                name="trs_phoneNumber"
                                value={props.values.trs_phoneNumber ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_menu"
                                label={`${t('propriete.labels.trs_menu')}  :`}
                                name="trs_menu"
                                value={props.values.trs_menu ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_email"
                                label={`${t('propriete.labels.trs_email')}  :`}
                                name="trs_email"
                                value={props.values.trs_email ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_website"
                                label={`${t('propriete.labels.trs_website')}  :`}
                                name="trs_website"
                                value={props.values.trs_website ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_facebook"
                                label={`${t('propriete.labels.trs_facebook')}  :`}
                                name="trs_facebook"
                                value={props.values.trs_facebook ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_instagram"
                                label={`${t('propriete.labels.trs_instagram')}  :`}
                                name="trs_instagram"
                                value={props.values.trs_instagram ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_tiktok"
                                label={`${t('propriete.labels.trs_tiktok')}  :`}
                                name="trs_tiktok"
                                value={props.values.trs_tiktok ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_address"
                                label={`${t('propriete.labels.trs_address')}  :`}
                                name="trs_address"
                                value={props.values.trs_address ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_gpsLink"
                                label={`${t('propriete.labels.trs_gpsLinks')} * :`}
                                name="trs_gpsLink"
                                value={props.values.trs_gpsLink ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_embedLink"
                                label={`${t('propriete.labels.trs_embedLink')} * :`}
                                name="trs_embedLink"
                                value={props.values.trs_embedLink ?? ""}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextField
                                id="trs_paymentMethod"
                                label={`${t('propriete.labels.trs_paymentMethod')}  :`}
                                name="trs_paymentMethod"
                                value={props.values.trs_paymentMethod ?? ""}
                                handleChange={props.handleChange}
                            />
                            <Grid container spacing={2}>
                                {/* Days Dropdown */}
                                <Grid item xs={4}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel id="trs_duration_days_label">{t('propriete.labels.trs_duration_days')}</InputLabel>
                                        <Select
                                            labelId="trs_duration_days_label"
                                            id="trs_duration_days"
                                            name="trs_duration_days"
                                            value={props.values.trs_duration_days ?? ""}
                                            onChange={props.handleChange}
                                        >
                                            <MenuItem value="">{t('propriete.options.select')}</MenuItem>
                                            {[...Array(31)].map((_, num) => (
                                                <MenuItem key={num} value={num}>
                                                    {num} {t('propriete.units.day', { count: num })}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Hours Dropdown */}
                                <Grid item xs={4}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel id="trs_duration_hours_label">{t('propriete.labels.trs_duration_hours')}</InputLabel>
                                        <Select
                                            labelId="trs_duration_hours_label"
                                            id="trs_duration_hours"
                                            name="trs_duration_hours"
                                            value={props.values.trs_duration_hours ?? ""}
                                            onChange={props.handleChange}
                                        >
                                            <MenuItem value="">{t('propriete.options.select')}</MenuItem>
                                            {[...Array(25)].map((_, num) => (
                                                <MenuItem key={num} value={num}>
                                                    {num} {t('propriete.units.hour', { count: num })}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Minutes Dropdown */}
                                <Grid item xs={4}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel id="trs_duration_minutes_label">{t('propriete.labels.trs_duration_minutes')}</InputLabel>
                                        <Select
                                            labelId="trs_duration_minutes_label"
                                            id="trs_duration_minutes"
                                            name="trs_duration_minutes"
                                            value={props.values.trs_duration_minutes ?? ""}
                                            onChange={props.handleChange}
                                        >
                                            <MenuItem value="">{t('propriete.options.select')}</MenuItem>
                                            {[...Array(60)].map((_, num) => (
                                                <MenuItem key={num} value={num}>
                                                    {num} {t('propriete.units.minute', { count: num })}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>


                            <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                <InputLabel id="trs-circuitFrequency-label">{`${t('propriete.labels.trs_circuitFrequency')} * :`}</InputLabel>
                                <Select
                                    id="trs-circuitFrequency"
                                    labelId="trs-circuitFrequency-label"
                                    label={`${t('propriete.labels.trs_circuitFrequency')} * :`}
                                    name="trs_circuitFrequency"
                                    value={props.values.trs_circuitFrequency ?? ""}
                                    onChange={props.handleChange}
                                >
                                    {[
                                        { value: "once_day", label: t('propriete.options.trs_circuitFrequency.once_day') },
                                        { value: "multiple_times_day", label: t('propriete.options.trs_circuitFrequency.multiple_times_day') },
                                        { value: "once_week", label: t('propriete.options.trs_circuitFrequency.once_week') },
                                        { value: "multiple_times_week", label: t('propriete.options.trs_circuitFrequency.multiple_times_week') },
                                        { value: "once_month", label: t('propriete.options.trs_circuitFrequency.once_month') },
                                        { value: "multiple_times_month", label: t('propriete.options.trs_circuitFrequency.multiple_times_month') },
                                        { value: "once_year", label: t('propriete.options.trs_circuitFrequency.once_year') },
                                        { value: "multiple_times_year", label: t('propriete.options.trs_circuitFrequency.multiple_times_year') },
                                        { value: "on_request", label: t('propriete.options.trs_circuitFrequency.on_request') },
                                        { value: "special_event", label: t('propriete.options.trs_circuitFrequency.special_event') },
                                        { value: "private_event", label: t('propriete.options.trs_circuitFrequency.private_event') },
                                    ]
                                    .map((item) => (
                                        <MenuItem key={item.value} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel>{`${t("propriete.labels.trs_langage")} `}</InputLabel>
                                <Select
                                    id="trs_langage"
                                    name="trs_langage"
                                    multiple
                                    value={props.values.trs_langage ? props.values.trs_langage.split(", ") : []} // Ensure value is an array
                                    onChange={(event) => {
                                        const selectedValues = event.target.value as string[];
                                        props.handleChange({
                                            target: {
                                                name: "trs_langage",
                                                value: selectedValues.join(", "), // Join selected values into a string
                                            },
                                        });
                                    }}
                                    renderValue={(selected) => (selected as string[]).join(", ")} // Display selected values as a comma-separated string
                                >
                                    {languageOptions[currentLang].map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel>{`${t("propriete.labels.trs_typeDeCuisine-Step")} `}</InputLabel>
                                <Select
                                    id="trs_typeDeCuisine"
                                    name="trs_typeDeCuisine"
                                    multiple
                                    value={props.values.trs_typeDeCuisine ? props.values.trs_typeDeCuisine.split(", ") : []} // Ensure value is an array
                                    onChange={(event) => {
                                        const selectedValues = event.target.value as string[];
                                        props.handleChange({
                                            target: {
                                                name: "trs_typeDeCuisine",
                                                value: selectedValues.join(", "), // Join selected values into a string
                                            },
                                        });
                                    }}
                                    renderValue={(selected) => (selected as string[]).join(", ")} // Display selected values as a comma-separated string
                                >
                                    {cuisineOptions[currentCuis].map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div>
                                <h3>{t("propriete.labels.trs_openingHours")}</h3>
                                {Object.entries(openingHours).map(([day, { open1, close1, open2, close2, isClosed, hasSecondTimeSlot }]) => (
                                    <div key={day}>
                                        <h4>{t(`label.${day}`)}</h4>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isClosed}
                                                    onChange={(e) => handleClosedChange(day as keyof OpeningHours, e.target.checked)}
                                                />
                                            }
                                            label={t("label.closed")}
                                        />
                                        {!isClosed && (
                                            <>
                                                {/* First Opening and Closing Times */}
                                                <div>
                                                    <label>{t("label.open1")}</label>
                                                    <input
                                                        type="time"
                                                        value={open1}
                                                        onChange={(e) => handleTimeChange(day as keyof OpeningHours, "open1", e.target.value)}
                                                    />
                                                    <label>{t("label.close1")}</label>
                                                    <input
                                                        type="time"
                                                        value={close1}
                                                        onChange={(e) => handleTimeChange(day as keyof OpeningHours, "close1", e.target.value)}
                                                    />
                                                </div>

                                                {/* Toggle for Second Opening and Closing Times */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={hasSecondTimeSlot}
                                                            onChange={(e) => handleToggleSecondTimeSlot(day as keyof OpeningHours, e.target.checked)}
                                                        />
                                                    }
                                                    label={t("label.enableSecondTimeSlot")}
                                                />

                                                {/* Second Opening and Closing Times */}
                                                {hasSecondTimeSlot && (
                                                    <div>
                                                        <label>{t("label.open2")}</label>
                                                        <input
                                                            type="time"
                                                            value={open2}
                                                            onChange={(e) => handleTimeChange(day as keyof OpeningHours, "open2", e.target.value)}
                                                        />
                                                        <label>{t("label.close2")}</label>
                                                        <input
                                                            type="time"
                                                            value={close2}
                                                            onChange={(e) => handleTimeChange(day as keyof OpeningHours, "close2", e.target.value)}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                <InputLabel id="trs-summary-label">{`${t('propriete.labels.trs_summary')} * :`}</InputLabel>
                                <Select
                                    id="trs-summary"
                                    labelId="trs-summary-label"
                                    label={`${t('propriete.labels.trs_summary')} * :`}
                                    name="trs_summary"
                                    value={props.values.trs_summary ?? ""}
                                    onChange={props.handleChange}
                                >
                                    {[
                                        { value: "Bâtiment architecturaux", label: t('propriete.options.trs_summary.batiments_architecturaux') },
                                        { value: "Bars et pubs", label: t('propriete.options.trs_summary.bars_pubs') },
                                        { value: "Boîtes de nuit", label: t('propriete.options.trs_summary.boites_nuit') },
                                        { value: "Casinos", label: t('propriete.options.trs_summary.casinos') },
                                        { value: "Cascades", label: t('propriete.options.trs_summary.cascades') },
                                        { value: "Centre commerciaux", label: t('propriete.options.trs_summary.centres_commerciaux') },
                                        { value: "Centres de conventions", label: t('propriete.options.trs_summary.centres_conventions') },
                                        { value: "Circuits de plusieurs jours", label: t('propriete.options.trs_summary.circuits_plusieurs_jours') },
                                        { value: "Circuits en 4x4", label: t('propriete.options.trs_summary.circuits_4x4') },
                                        { value: "Circuits en voiture", label: t('propriete.options.trs_summary.circuits_voiture') },
                                        { value: "Circuits privés", label: t('propriete.options.trs_summary.circuits_prives') },
                                        { value: "Circuits pédestres", label: t('propriete.options.trs_summary.circuits_pedestres') },
                                        { value: "Complexes sportifs", label: t('propriete.options.trs_summary.complexes_sportifs') },
                                        { value: "Croisières", label: t('propriete.options.trs_summary.croisieres') }, // Cruise
                                        { value: "Espace Naturels et sauvages", label: t('propriete.options.trs_summary.espaces_naturels') },
                                        { value: "Excursions d'une journée", label: t('propriete.options.trs_summary.excursions_journee') },
                                        { value: "Grands magasins", label: t('propriete.options.trs_summary.grands_magasins') },
                                        { value: "Jardins", label: t('propriete.options.trs_summary.jardins') },
                                        { value: "Jet ski", label: t('propriete.options.trs_summary.jet_ski') }, // Jet Ski
                                        { value: "Kayak", label: t('propriete.options.trs_summary.kayak') }, // Kayak
                                        { value: "Manifestations Sportives", label: t('propriete.options.trs_summary.manifestations_sportives') },
                                        { value: "Marché aux puces et marché de rue", label: t('propriete.options.trs_summary.marches_puces') },
                                        { value: "Monuments et statues", label: t('propriete.options.trs_summary.monuments_statues') },
                                        { value: "Monuments et points d'intérêt", label: t('propriete.options.trs_summary.monuments_points_interet') },
                                        { value: "Phares", label: t('propriete.options.trs_summary.phares') },
                                        { value: "Petits bateaux", label: t('propriete.options.trs_summary.petits_bateaux') }, // Small Boat
                                        { value: "Plages", label: t('propriete.options.trs_summary.plages') },
                                        { value: "Plans d'eaux", label: t('propriete.options.trs_summary.plans_eaux') },
                                        { value: "Pirogues", label: t('propriete.options.trs_summary.pirogues') }, // Pirogue
                                        { value: "Ponts", label: t('propriete.options.trs_summary.ponts') },
                                        { value: "Promenades à cheval", label: t('propriete.options.trs_summary.promenades_cheval') }, // Horse Tour
                                        { value: "Salons de massage", label: t('propriete.options.trs_summary.salons_massage') },
                                        { value: "Sentiers historiques", label: t('propriete.options.trs_summary.sentiers_historiques') },
                                        { value: "Sites religieux", label: t('propriete.options.trs_summary.sites_religieux') },
                                        { value: "Spas et centres de bien-être", label: t('propriete.options.trs_summary.spas_centres_bien_etre') },
                                        { value: "Visites en bus", label: t('propriete.options.trs_summary.visites_bus') },
                                        { value: "Volcans", label: t('propriete.options.trs_summary.volcans') },
                                    ]
                                    .sort((a, b) => a.label.localeCompare(b.label)) // Sort alphabetically by label
                                    .map((item) => (
                                        <MenuItem key={item.value} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>                       
                            
                        </>
                    )}
    
                    {(SearchTypeName === "apts" || SearchTypeName === "htls") && (
                        <>
                            <PropertyTextField
                                id="propertyName"
                                label={`${t('propriete.labels.nomDeLaPropriete')} * :`}
                                name="name"
                                value={props.values.name}
                                handleChange={props.handleChange}
                            />
                            <PropertyTextFieldNumber
                                id="propertyMaximumGuests"
                                label={`${t('propriete.labels.nombreMaximumDInvites')} * :`}
                                name="maximumGuests"
                                value={props.values.maximumGuests || 0}
                                handleChange={(e) =>
                                    props.handleChange({ target: { name: 'maximumGuests', value: Number(e.target.value) } })
                                }
                            />
                            <PropertyTextFieldNumber
                                id="propertyRooms"
                                label={`${t('propriete.labels.nombreDeChambres')} * :`}
                                name="rooms"
                                value={props.values.rooms || 0}
                                handleChange={(e) =>
                                    props.handleChange({ target: { name: 'rooms', value: Number(e.target.value) } })
                                }
                            />
                            <PropertyTextFieldNumber
                                id="propertyBeds"
                                label={`${t('propriete.labels.nombreDeLits')} * :`}
                                name="lit"
                                value={props.values.lit || 0}
                                handleChange={(e) =>
                                    props.handleChange({ target: { name: 'lit', value: Number(e.target.value) } })
                                }
                            />
                            <PropertyTextFieldNumber
                                id="propertyBathrooms"
                                label={`${t('propriete.labels.nombreDeBathrooms')} * :`}
                                name="bathrooms"
                                value={props.values.bathrooms || 0}
                                handleChange={(e) =>
                                    props.handleChange({ target: { name: 'bathrooms', value: Number(e.target.value) } })
                                }
                            />
                            <PropertyTextFieldNumber
                                id="propertyToilette"
                                label={`${t('propriete.labels.toilette')} * :`}
                                name="toilette"
                                value={props.values.toilette || 0}
                                handleChange={(e) =>
                                    props.handleChange({ target: { name: 'toilette', value: Number(e.target.value) } })
                                }
                            />
                        </>
                    )}
    
                    <Grid item lg={12} sm={12} xs={12}>
                        {/* Optional label for equipments */}
                    </Grid>
    
                    <Grid item lg={12} md={12} sm={12} xs={12} className={classes.inpuText}>
                        <Grid container>
                            {tab_eq.map((cat: any) => (
                                <React.Fragment key={cat.categorie}>
                                    <Grid item xs={12} className={classes.category}>
                                        <span>{cat.categorie}</span>
                                    </Grid>
                                    {cat.equipement.map((eq: any) => {
                                        const equipmentName = i18n.language === "fr" ? eq.name?.fr : eq.name?.en;
                                        return (
                                            <Grid item lg={4} md={4} sm={4} xs={6} key={eq._id}>
                                                <CheckableTreeItem
                                                    onChecked={() => handleCheck(eq)}
                                                    checkable
                                                    node={{
                                                        label: <span style={{ color: '#999', fontSize: 'smaller' }}>{equipmentName}</span>,
                                                        checked: props.equipments.find((el: any) => el === eq._id) !== undefined
                                                    }}
                                                />
                                            </Grid>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </MuiPickersUtilsProvider>
        </LocalizationProvider>
    );      
}
